// extracted by mini-css-extract-plugin
export var card = "_mw-0";
export var content = "_mw-2";
export var details = "_mw-3";
export var icon = "_mw-1";
export var iconBlue = "_mw-5";
export var iconBrand = "_mw-4";
export var iconGrayBlue = "_mw-6";
export var iconGreen = "_mw-7";
export var iconIndigo = "_mw-8";
export var iconOrange = "_mw-9";
export var iconPurple = "_mw-a";
export var iconRed = "_mw-b";
export var iconWarning = "_mw-c";